module.exports = __webpack_public_path__ + "static/media/unity.42c34404.svg";